"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminBffMethods = void 0;
const repository_types_1 = require("../webapp/repository.types");
const app_methods_1 = require("./app.methods");
const patient_methods_1 = require("./patient.methods");
const prescription_methods_1 = require("./prescription.methods");
const promotion_methods_1 = require("./promotion.methods");
const user_methods_1 = require("./user.methods");
exports.adminBffMethods = (0, repository_types_1.generateRepositoryMethods)(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, app_methods_1.appRepositoryMethods), patient_methods_1.patientRepositoryMethods), prescription_methods_1.prescriptionRepositoryMethods), promotion_methods_1.promotionRepositoryMethods), user_methods_1.userRepositoryMethods));
//# sourceMappingURL=repository.types.js.map